export const dynamicCssPagesService = window.dynamicCssPagesServiceModule.dynamicCssPagesService;